import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ReportService } from '../../../../../common/services/Report.service';
import { ExportService } from '../../../../../common/services/Export.service';
import { ToastrService } from 'ngx-toastr';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { HistoryConst } from './history.const';
import { TimeWorker } from '../../../../../common/utils/timeWorker';
import { BsModalService, trLocale } from 'ngx-bootstrap';
import { UserService } from '../../../../../common/services/User.service';
import { QueueService } from '../../../../../common/services/Queue.service';
import { CampaignService } from '../../../../../common/services/Campaign.service';

@Component({
  selector: 'report-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.css', '../report.component.css'],
  providers: [ReportService, BsModalService, ExportService, UserService, QueueService, CampaignService],
})
export class HistoryComponent implements OnInit {
  @ViewChild('audioFile') audioFile: ElementRef;
  public modelFilter: any = {};
  public displayModel: any = {};
  public data: any;
  public audio_path: any;
  public data_page_divide: any;
  public exportData: any = [];
  public allAgent: any = [];
  public allQueue: any = [];
  public campaigns: any = [];
  public displayColumns: any = [];
  public modalRef2: any = {};
  totalPage = 0;
  totalItem = 0;
  currentPage = 1;

  protected readonly trLocale = trLocale;

  constructor(
    private reportService: ReportService,
    private exportService: ExportService,
    private modalService: BsModalService,
    private userService: UserService,
    private queueService: QueueService,
    private campaignService: CampaignService,
    private toastr: ToastrService
  ) {
    this.modelFilter = {
      from: moment().add('-30', 'days').format('YYYY-MM-DD HH:mm'),
      to: moment().format('YYYY-MM-DD HH:mm'),
      callType: -1,
      caller: '',
      called: '',
      callId: '',
      agentId: '',
      username: '',
      duration: '',
      campaignId: '',
      queueId: '',
    };
    this.swapModel(0);
    this.displayColumns = HistoryConst.displayColumns();
  }

  swapModel(type) {
    if (type == 0) {
      this.displayModel = {
        from: this.modelFilter.from,
        to: this.modelFilter.to,
        source: this.modelFilter.callType,
        calleds: this.modelFilter.called,
        caller: this.modelFilter.caller,
        callId: this.modelFilter.callId,
        duration: this.modelFilter.duration,
        campaigns: this.modelFilter.campaignId,
        queues: this.modelFilter.queueId,
        agents: this.modelFilter.username,
      };
    } else {
      this.modelFilter = {
        from: this.displayModel.from,
        to: this.displayModel.to,
        callType: this.displayModel.source,
        called: this.displayModel.calleds,
        caller: this.displayModel.caller,
        callId: this.displayModel.callId,
        duration: this.displayModel.duration,
        campaignId: this.displayModel.campaigns,
        queueId: this.displayModel.queues,
        agentId: this.displayModel.agents,
      };
    }
  }

  ngOnInit() {
    this.getAgentList();
    this.getAllQueue();
    this.getAllCampaign();
    this.loadData(1);
  }

  changeTime(type) {
    let start: any = moment().format('YYYY-MM-DD HH:mm');

    const end: any = moment().format('YYYY-MM-DD HH:mm');

    switch (type) {
      case 'year': {
        start = moment().add('-365', 'days').format('YYYY-MM-DD HH:mm');
        break;
      }
      case 'month': {
        start = moment().add('-30', 'days').format('YYYY-MM-DD HH:mm');
        break;
      }
      case 'week': {
        start = moment().add('-7', 'days').format('YYYY-MM-DD HH:mm');
        break;
      }
      case 'day': {
        start = moment().add('-1', 'days').format('YYYY-MM-DD HH:mm');
        break;
      }
      case 'hour': {
        start = moment().add('-1', 'hours').format('YYYY-MM-DD HH:mm');
        break;
      }
      case 'minute': {
        start = moment().add('-30', 'minutes').format('YYYY-MM-DD HH:mm');
        break;
      }
      default:
        break;
    }
    this.modelFilter['from'] = start;
    this.modelFilter['to'] = end;
    this.loadData(1);
  }

  loadData(research?: any) {
    if (research) {
      this.currentPage = 1;
    }
    this.reportService.reportHistory(this.modelFilter).subscribe(res => {
      if (res.data) {
        this.data = res.data;
      } else {
        this.data = [
          {
            startTime: null,
            endTime: null,
            ringTime: 0,
            connectTime: 0,
            acdTime: 0,
            callType: 0,
            waitingTime: 0,
            holdTime: 0,
            caller: null,
            called: null,
            callId: null,
            agentId: null,
            username: null,
            duration: 0,
            campaignId: null,
            queueId: null,
            url: null,
          },
        ];
      }
      this.totalItem = this.data.length;
      this.totalPage =
        this.data.length % 10 != 0 ? Math.floor(this.data.length / 10) + 1 : Math.floor(this.data.length / 10);
      const begin = (this.currentPage - 1) * 10;
      const end = this.currentPage * 10;
      this.data_page_divide = this.data.slice(begin, end);
      this.data_page_divide.map(res => {
        const campaign = this.campaigns.find(c => c.id == res.campaignId);
        const queue = this.allQueue.find(c => c.id == res.queueId);
        res.display_status = HistoryConst.displayStatusColumn(res.connectTime);
        res.display_url = HistoryConst.displayFileUrlColumn(res.connectTime);
        res.agentId = HistoryConst.displayAgentColumn(res, this.allAgent);
        res.queueId = HistoryConst.displayQueueColumn(res, this.allQueue);
        res.callType = HistoryConst.callType(res.callType);
        res.duration = TimeWorker.formatSecondToHour(res.duration);
        res.waitingTime = TimeWorker.formatSecondToHour(res.waitingTime);
        res.acdTime = TimeWorker.formatSecondToHour(res.acdTime);
        res.campaignId = campaign ? campaign.text : '';
        res.queueId = queue ? queue.text : '';
        return res;
      });
    });
  }

  submitFilter(item?: any) {
    if (item) {
      this.displayModel = item;
    }
    if (this.displayModel.from) {
      this.displayModel.from = moment(this.displayModel.from).format('YYYY-MM-DD HH:mm');
    }
    if (this.displayModel.to) {
      this.displayModel.to = moment(this.displayModel.to).format('YYYY-MM-DD HH:mm');
    }
    this.swapModel(1);
    this.loadData(1);
  }

  export() {
    this.exportData = [];
    this.data.forEach(data => {
      const dataExport = {};
      this.displayColumns.forEach(d => {
        dataExport[d.title] = data[d.key];
      });
      this.exportData.push(dataExport);
    });
    this.exportService.exportExcel(
      this.exportData,
      'Báo cáo Lịch sử cuộc gọi ' + moment(new Date()).format('YYYY-MM-DD HH-mm')
    );
  }

  setPage(page: number) {
    if (page <= this.totalPage) {
      if (page < 1) {
        page = 1;
      }
      if (page != this.currentPage) {
        this.currentPage = page;
        this.loadData();
      }
    } else {
      page = this.totalPage;
      $('#inputPage').val(page);
      this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      if (page <= this.totalPage) {
        // this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
        if (page < 1) {
          page = 1;
        }
        if (page != this.currentPage) {
          this.currentPage = page;
          this.loadData();
        }
      }
    }
  }

  goPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    }
  }

  getAgentList() {
    this.userService.all().subscribe(res => {
      const agentList = [];
      res.data.list.forEach((c: any) => {
        agentList.push({
          text: c.name,
          id: c.agent_id,
          email: c.email,
          group_id: c.group_id,
        });
      });
      this.allAgent = agentList;
    });
  }
  getAllQueue() {
    this.queueService.list({}).subscribe(res => {
      const list = [];
      res.data.queues.forEach((c: any) => {
        list.push({
          text: c.DESCRIPTION,
          id: c.QUEUE_ID.toString(),
        });
      });
      this.allQueue = list;
    });
  }
  getAllCampaign() {
    this.campaignService.all({}).subscribe(res => {
      const campaignList = [];
      res.data.list.forEach((c: any) => {
        campaignList.push({
          text: c.name,
          id: c._id,
        });
      });
      this.campaigns = campaignList;
    });
  }
  handleAction(type: any, item?: any) {
    if (type == 'display_url') {
      this.audio_path = item.url;
      if (item.display_url) {
        const config = {
          backdrop: true,
          ignoreBackdropClick: false,
          keyboard: false,
          class: 'mt-100',
        };
        this.modalRef2 = this.modalService.show(this.audioFile, config);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/report/history/history.component.ts